import styled from 'styled-components';
export const Wrapper = styled.div`
  width: 435px;
  max-width: 84%;
  color: #fff;
  margin: auto;
  margin-top: 15px;
`;
export const Title = styled.h1`
  font-size: 24px;
  font-weight: 700;
  line-height: 28.8px;
  text-align: center;
`;
export const Subtitle = styled.h2`
  font-size: 16px;
  font-weight: 400;
  line-height: 19.2px;
  margin-top: 14px;
  margin-bottom: 33px;
  text-align: center;
`;
export const CopyHelp = styled.div`
  color: #fff;
  font-size: 14px;
  font-style: italic;
  font-weight: normal;
  line-height: 20px;
  opacity: 0.6;
  text-align: center;
`;